import { Component } from "@angular/core";
import { SearchBoxDlgDelegate } from "../../../common";

@Component({
  selector: "manifest-search-box",
  templateUrl: "./manifest-search-box.html",
  standalone: false,
  inputs: ["searchCriteria"],
  outputs: ["searchCriteriaChanged"],
})
export class ManifestSearchBox extends SearchBoxDlgDelegate {}
